import { render, staticRenderFns } from "./zmdetbanner.vue?vue&type=template&id=138644d1&scoped=true&"
import script from "./zmdetbanner.vue?vue&type=script&lang=js&"
export * from "./zmdetbanner.vue?vue&type=script&lang=js&"
import style0 from "./zmdetbanner.vue?vue&type=style&index=0&id=138644d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138644d1",
  null
  
)

export default component.exports